"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Source: https://github.com/chipbell4/nes-sequencer

var real = exports.real = Array.from({ length: 8192 }, function (_, n) {
  return n === 0 ? 0 : 4 / (n * Math.PI) * Math.sin(Math.PI * n * 0.18);
});

var imag = exports.imag = real.map(function () {
  return 0;
});